import React, {useState} from 'react'
import RenderFields from "../../../common/ui/render-fields";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import _ from "lodash";
import {SEARCH_TARGETING_INPUT_FIELDS} from "../../constants/targeting.constant";
import {FACEBOOK_SEARCH_TARGETING_TYPES} from "../../constants/facebook-constant";

const emptyFilterCriteria: any = {};
let allFilterFields = _.groupBy(SEARCH_TARGETING_INPUT_FIELDS, 'group')['detail'];
// const defaultSelectedField = {name: 'type', value: FACEBOOK_SEARCH_TARGETING_TYPES.COUNTRY};

const SearchTargetingFilters = ({filterCriteria, setFilterCriteria, startTargetSearch}) => {
    const [targetingFilterFields, setTargetingFilterFields] = useState(prepareInputFields(allFilterFields, null, filterCriteria));

    const handleFilterChanges = (event) => {
        const existingFilterCriteria = {...filterCriteria};

        const {name} = event.target;
        if (name === 'type') {
            const newFields = prepareInputFields(allFilterFields, event.target, existingFilterCriteria);
            setTargetingFilterFields(newFields);
        }

        console.log('existingFilterCriteria', existingFilterCriteria);
        console.log('event', event);

        handleFieldValueChanges(event, existingFilterCriteria, setFilterCriteria);
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
    }

    return (
        <>
            <div className="flex flex-wrap justify-start w-full">
                <RenderFields
                    parentForm={filterCriteria}
                    handleDetailChanges={handleFilterChanges}
                    fieldList={targetingFilterFields}
                    enableEdit={true}
                    fieldClassName={`mr-2`}/>

                {targetingFilterFields.length > 0 &&
                    <div className="w-fit mt-1 ml-2">
                        <button
                            onClick={() => clearFilterCriteria()}
                            className="button-gray-outline mt-10 px-2 py-1">
                            Clear Filters
                        </button>
                    </div>
                }

                <div className={'w-fit mt-1 ml-2'}>
                    <button
                        className="button-green mt-10 px-2 py-1"
                        onClick={startTargetSearch}>
                        Search
                    </button>
                </div>
            </div>
        </>
    )
}

export default SearchTargetingFilters
